<template>
  <v-row>
    <!-- kitchen sink
    - ${$t('menu.comitions')}
    -->
    <v-col cols="12">
      <app-card-code :title="`${$t('menu.configuration')} / Newsletter`">
        <NewlettersForm></NewlettersForm>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import NewlettersForm from './form/Newletters.vue'

export default {
  components: {
    AppCardCode,
    NewlettersForm,
  },
}
</script>
